module.exports = __webpack_public_path__ + "static/img/evse_group.8f899b8d.png";